import React, { FC, PropsWithChildren } from 'react'
import { ProductDetailsContext } from './types'
import { productContext } from './Context'

/* istanbul ignore next */
export const ProductProvider: FC<
  PropsWithChildren<{ context: ProductDetailsContext }>
> = ({ context, children }) => {
  return (
    <productContext.Provider value={context}>
      {children}
    </productContext.Provider>
  )
}
